import { createApp } from 'vue';
import TgsToJpgConverter from '@/Components/TgsToJpgConverter.vue';
import '@styles/app.css';

createApp(TgsToJpgConverter).mount('#tgs-to-jpg-converter');
